import { useEffect } from 'react';
import Lenis from 'lenis';
import { useReducedMotion } from 'framer-motion';

// Inertial scrolling. Skipped for users who prefer reduced motion.
export const SmoothScroll = () => {
    const reduced = useReducedMotion();
    useEffect(() => {
        if (reduced) return undefined;
        const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, [reduced]);
    return null;
};
